/**
 * @flow
 * @relayHash 822544993ddb02ff38290d8f344fdc06
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type duplicateHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type duplicateEventMutationVariables = {|
  input: duplicateHyeventInput
|};
export type duplicateEventMutationResponse = {|
  +duplicateHyevent: ?{|
    +hyevent: ?{|
      +id: string,
      +title: string,
      +maxNoOfGuests: number,
      +additionalGuestAllowed: boolean,
      +maxAdditionalGuests: ?number,
      +ctaText: string,
      +messageTitle: string,
      +message: string,
      +address: string,
      +status: string,
      +propertyId: string,
      +startAt: any,
      +endAt: any,
      +publishAt: ?any,
      +cancelReason: ?string,
      +rsvpedCount: number,
      +image: {|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
      +document: ?{|
        +createdAt: any,
        +dimension: ?string,
        +fileSize: number,
        +fileType: string,
        +fileUrl: string,
        +id: string,
        +name: string,
        +thumbnailUrl: ?string,
      |},
      +smsEnabled: ?boolean,
      +displayTime: ?string,
    |}
  |}
|};
export type duplicateEventMutation = {|
  variables: duplicateEventMutationVariables,
  response: duplicateEventMutationResponse,
|};
*/


/*
mutation duplicateEventMutation(
  $input: duplicateHyeventInput!
) {
  duplicateHyevent(input: $input) {
    hyevent {
      id
      title
      maxNoOfGuests
      additionalGuestAllowed
      maxAdditionalGuests
      ctaText
      messageTitle
      message
      address
      status
      propertyId
      startAt
      endAt
      publishAt
      cancelReason
      rsvpedCount
      image {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      document {
        createdAt
        dimension
        fileSize
        fileType
        fileUrl
        id
        name
        thumbnailUrl
      }
      smsEnabled
      displayTime
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "duplicateHyeventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileType",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileSize",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileUrl",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimension",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "thumbnailUrl",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "duplicateHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "duplicateHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxNoOfGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxAdditionalGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messageTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "startAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelReason",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "image",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              (v3/*: any*/),
              (v2/*: any*/),
              (v4/*: any*/),
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              (v6/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "smsEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayTime",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "duplicateEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v7/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "duplicateEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v7/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "duplicateEventMutation",
    "id": null,
    "text": "mutation duplicateEventMutation(\n  $input: duplicateHyeventInput!\n) {\n  duplicateHyevent(input: $input) {\n    hyevent {\n      id\n      title\n      maxNoOfGuests\n      additionalGuestAllowed\n      maxAdditionalGuests\n      ctaText\n      messageTitle\n      message\n      address\n      status\n      propertyId\n      startAt\n      endAt\n      publishAt\n      cancelReason\n      rsvpedCount\n      image {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n      document {\n        createdAt\n        dimension\n        fileSize\n        fileType\n        fileUrl\n        id\n        name\n        thumbnailUrl\n      }\n      smsEnabled\n      displayTime\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '87df121b6a2b8872518e8f40e9f64772';
module.exports = node;
